import styled from "styled-components";
import {styledByTheme} from "../../../themes/architecture/styled-by-theme";

const SideMenuHorizontalLineDefaultBox = styled.div`
  width: 100%;
  height: 2px;
  margin-top: 2rem;
  margin-bottom: 3.8rem;
  padding: 0 1rem;
  background-color: ${props => props.theme.colors.horizontalLineBackgroundColor};
  background-image: ${props => props.theme.colors.horizontalLineBackgroundImage};

  @media ${({theme}) => theme.mediaQuery.lAndBelow } {
    margin-bottom: 3rem;
  }
  
`


const SideMenuHorizontalLineMrGreenBox = styled(SideMenuHorizontalLineDefaultBox)`
  margin-top: 0;
`

export const SideMenuHorizontalLineBox = styledByTheme(SideMenuHorizontalLineDefaultBox)
    .forMrGreen(SideMenuHorizontalLineMrGreenBox)
    .apply();